import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import Logo from "../assets/images/PAYLOFT_LOGO.png";

import Migrate from "../assets/images/migrate.png";
import ProfilePhoto from "../assets/images/profile-photo.png";
import { useAuth } from "../context/AuthContextProvider";

const ReportNav = () => {
  const location = useLocation();
  const { user, userrole } = useAuth();
  const inactiveClass = "flex items-center py-2 px-6 gap-3 text-gray-400";
  const activeClass =
    // "flex items-center py-6 px-5 gap-3 text-text-orange bg-gradient-to-r from-text-orange via-transparent to-transparent bg-no-repeat bg-left ";

    "flex items-center py-2 px-6 gap-3 text-primary relative";

  const getLinks = () => {
    const commonLinks = [
      {
        to: "/reports",
        text: "Transaction",
      },
      {
        to: "/reports/audits",
        text: "Audit",
      },
    ];

    if (userrole.role === "Business Support Maker") {
      return [
        {
          to: "/reports",
          text: "Transaction",
        },
      ];
    }

    if (userrole.role === "Business Support") {
      return [
        {
          to: "/reports",
          text: "Transaction",
        },
      ];
    }

    if (userrole.role === "Risk User") {
      return [
        {
          to: "/reports/audits",
          text: "Audit",
        },
      ];
    }

    return commonLinks;
  };

  const links = getLinks();

  return (
    <div className="bg-arena-background h-full">
      <div className="flex">
        <div className="bg-white pt-4 w-[218px] h-[1047px] flex flex-col justify-between">
          <div className="flex flex-col items-center">
            <img
              src={window.__TENANT__?.logo ?? Logo}
              alt="logo"
              className="w-[150px] h-auto"
            />
            <div className="w-[191.98px] ">
              <NavLink className="flex items-center px-5 gap-3" to="/dashboard">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.4">
                      <path
                        d="M2.35 12.35L5.14 15.14C5.46 15.46 6 15.24 6 14.79L6 13L20 13C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11L6 11L6 9.20997C6 8.75997 5.46 8.53997 5.15 8.85997L2.36 11.65C2.16 11.84 2.16 12.16 2.35 12.35Z"
                        fill="#030229"
                      />
                    </g>
                  </svg>
                </span>
                <p className="text-gray-400 text-[12px] font-semibold">
                  Main Menu
                </p>
              </NavLink>

              <p className="text-text-orange px-5 text-base font-semibold mt-4">
                Reports
              </p>
              <div className="">
                {links.map((link, index) => (
                  <NavLink
                    key={index}
                    to={link.to}
                    className={
                      location.pathname === link.to
                        ? activeClass
                        : inactiveClass
                    }
                  >
                    <p className="text-base font-semibold">{link.text}</p>
                    {location.pathname === link.to ? (
                      <div className="absolute top-1/2 left-[65%] transform -translate-y-1/2 w-12 h-px bg-primary"></div>
                    ) : null}
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full p-5">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReportNav;
